import axios from "axios";

function NetworkSubscriptionRefreshService() {
  return axios.get(process.env.REACT_APP_API_HOST + "/network/refreshSubscription", {
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
}

export default NetworkSubscriptionRefreshService;
